import React from "react";
import styled from "styled-components";

export const PEV = () => {
  return (
    <Wrapper>
      <div className="PR-r1">
        <h2 className="heading-2">Pre Exposure Vaccination for Rabies</h2>
        <p>
          Rabies is one of the oldest diseases, caused by a virus spread through
          the bite/ scratch of a rabid animal or an infected human, to a healthy
          person. According to the World Health Organization, every year more
          than 50,000 people die from the disease. However, the good news is
          that it is 100% preventable with appropriate prophylactic vaccination.
        </p>
        <p>
          Vaccination against rabies is a crucial step in having protection
          against the virus. It can be used in two distinct situations:
        </p>
        <ul>
          <li>
            Vaccination before the exposure to rabies virus, i.e. pre-exposure
            vaccination
          </li>
          <li>
            Vaccination to prevent the development of clinical rabies after
            exposure has occurred, i.e. post-exposure prophylaxis.
          </li>
        </ul>
        <p>
          Vaccination after exposure had been a common practice for a long time.
          However, awareness regarding advantages of pre-exposure vaccination is
          catching up as a proactive measure.
        </p>
        <h2 className="heading-2">
          Pre-exposure rabies prophylaxis (PrEP) (Vaccination):
        </h2>
        <p>
          Pre-exposure Prophylaxis (PrEP) is a course of rabies vaccination that
          is administered to protect a person from getting rabies prior to an
          exposure to a rabid animal/ any other mode of exposure to rabies
          virus. People who benefit most from this pre-exposure prophylaxis are
          the ones who have high risk of coming in contact with saliva, body
          fluids, or tissues of rabid animals, increasing their risk of rabies.
          After receiving the pre-exposure vaccine, if anyone gets exposed to
          rabies, she/ he needs to have only 2 doses of modern tissue/ cell
          culture anti-rabies vaccine. Also rabies immunoglobulin will not be
          required as part of post exposure treatment, which is costly and
          sometimes difficult to procure.
        </p>
        <h2 className="heading-2">
          Advantages of pre-exposure prophylaxis (Vaccination):
        </h2>
        <ul>
          <li>
            May protect patients when post exposure prophylaxis is delayed;
          </li>
          <li>Faster antibody responses to post exposure prophylaxis; and</li>
          <li>
            Reduces the number of post exposure prophylaxis to 2 doses and also
            there is no by removing the need for rabies immunoglobulin and
            reducing
          </li>
        </ul>
        <h2 className="heading-2">How pre-exposure prophylaxis works:</h2>
        <p>
          Pre-exposure prophylaxis by administration of rabies vaccines
          stimulates body’s immune system to produce antibodies against the
          rabies virus. The antibodies develop within seven to 14 days after
          being immunized and are able to neutralize the rabies virus on
          exposure. Pre-exposure vaccination also leads to formation of memory
          immune cells which stay in the body throughout life. On re-exposure
          they are able to stimulate production of neutralizing antibodies in
          short time. However, two more re-exposure vaccination doses are
          recommended for boosting good amount of antibodies quickly for
          immediate availability to neutralize any amount of rabies virus that
          may get into the body on re-exposure.
        </p>
        <h2 className="heading-2">
          Who should consider receiving pre-exposure vaccination?
        </h2>
        <p>
          Pre-exposure rabies vaccination is indicated for those with a
          relatively high risk of rabies exposure. This includes:
        </p>
        <h3 className="heading-3">Children below 15 years of age</h3>
        <p>
          Children are the most frequently exposed age group and represent about
          50% of human exposures in canine rabies infected areas. Children while
          playing outdoors or walking to school while playing with street dogs
          are vulnerable to dog bites. These children at this age also have a
          habit of not reporting to elders if they are bitten, scratched or
          licked by a dog. Hence, pre-exposure vaccination is a safe and
          effective method of preventing rabies in children. Children after
          preventive vaccination usually have a long-lasting immunity against
          rabies. As a parent, you should also teach your children to tell you
          if they are ever bitten by any animal. WHO also recommends
          pre-exposure vaccination for children living in highly endemic regions
          as they are at particular risk of attacks from street dogs.
        </p>
        <h3 className="heading-3">
          Individuals who go for early morning walks or jogging in the lonely
          lanes or less crowded areas or forests
        </h3>
        <p>
          If you are a person who goes for early morning walks or jogging, then
          you are vulnerable to dog bites since unvaccinated community dogs are
          commonly observed on the streets. There are innumerable bites from
          stray dogs reported everyday. In such cases, pre-exposure prophylaxis
          against rabies can be helpful. Also, people who will not have ready
          access to medical care such as those backpacking to a remote area,
          should also consider PrEP.
        </p>
        <h3 className="heading-3">Pet owners and Animal lovers</h3>
        <p>
          Animal bite is not the only way, one gets rabies. You can also get the
          disease if the animal licks a cut on your hand or your face. The
          rabies virus can spread inside the body through mucosal membranes,
          including your eyes, ears, nose and mouth. So, if you are likely to be
          involved in activities that bring you into contact with animals, you
          should consider pre exposure prophylaxis for rabies. In addition, the
          following people are also considered as high risk population and
          advised to take vaccination as pre-exposure prophylaxis:
        </p>
        <ul>
          <li>People who handle animals</li>
          <li>Laboratory workers</li>
          <li>Healthcare workers who come into contact with rabies patients</li>
          <li>
            People visiting from a part of the world where rabies is not common
            to part(s) of the world where rabies is common
          </li>
        </ul>

        <h2 className="heading-2">Pre-Exposure Rabies Vaccination Guide</h2>
        <p>
          Pre-exposure prophylaxis consists of one dose of intramuscular or
          intradermal injection of vaccine at one site in deltoid region on days
          0, 7 and 21 or 28. Routine booster vaccine doses after primary rabies
          vaccination are not required. However, regular antibody titer
          screening is recommended for those who work with live virus and a
          booster dose is recommended when the titer falls below 0.5 IU/ ml when
          estimated by RFFIT (Rapid Fluorescent Focus Inhibition Test) method.
        </p>
        <h2 className="heading-2">
          Could there be undesirable effects from the pre-exposure rabies
          vaccines?
        </h2>
        <p>
          Cell/ Tissue cultured Rabies vaccine are considered safe and effective
          based on numerous clinical studies and past experience of use in
          millions of people. In some cases, minor local reactions, such as
          transient pain, itching, swelling, and redness may occur at the site
          of the injection. These reactions usually subside in a few days.
        </p>
        <p>
          However, some people may experience side effects such as headache,
          body pain, feeling unwell, sensation of vomiting and dizziness. Very
          rarely there may be high fever, abdominal symptoms, swollen glands,
          multiple red patches, rash, joint pain. Occasionally, there may be
          some severe reaction known as anaphylaxis which may cause shortness of
          breath and low blood pressure.It is important to intimate the treating
          doctor immediately in case of any side effect. All side effects can be
          effectively managed if treated promptly.
        </p>
        <h2 className="heading-2">
          What are the contraindications of pre-exposure rabies vaccination?
        </h2>
        <p>
          Pre-Exposure Rabies vaccination is contraindicated in severe febrile
          illness, acute or chronic progressive illness and known
          hypersensitivity to any of the components of the vaccine
        </p>
        <p>
          The pre-exposure rabies vaccination must be given with caution in:
        </p>
        <ul>
          <li>Pregnant and breastfeeding women</li>
          <li>
            Individuals who have a history of hypersensitivity to any vaccine
          </li>
          <li>People who are sick or have any infection</li>
          <li>People who are known to have low immunity</li>
        </ul>
        <h3 className="heading-3">Reference:</h3>
        <p className="m-0">
          Rabies Vaccinations and immunization. Accessed on 27.11.2020 from:
          <a href="https://www.who.int/ith/vaccines/rabies/en/">
            https://www.who.int/ith /vaccines/rabies/en/# .
          </a>
        </p>
        <p className="m-0">
          Pre-exposure rabies prophylaxis: a systematic review. Accessed on
          27.11.2020 from:
          <a href="https://www.who.int/bulletin/volumes/95/3/16-173039/en/">
            https://www.who.int /bulletin/volumes/95/3/16-173039/en/
          </a>
          .
        </p>
        <p className="m-0">
          WHO Expert Consultation on Rabies, Third Report, WHO Technical Report
          Series 982 and 1012
        </p>
      </div>
    </Wrapper>
  );
};
const Wrapper = styled.section``;
